import { FAQEntry } from './FAQModal';

export const FAQ_LargestRecord: FAQEntry = {
  title: 'What is available balance?',
  content: [
    'Private assets on Aleo, like PARC, PART, and ALEO, are represented in separate onchain data structures called records, much like cash notes in your physical wallet.',
    'Transactions that spend these records, like private ALEO transfers and entering giveaways with PART, can only accept one record at a time.',
    'For these transactions, your available balance for a particular asset is the record with the largest value.',
  ],
};
